import React, { useCallback, useEffect, useState } from "react"
import { Col, Form, Row } from "react-bootstrap"
import { useNavigate, useParams } from "react-router-dom"
import { ApiClient } from "../../ApiClient"
import { useAuth0 } from "@auth0/auth0-react"
import { MessageType, useMessageReport } from "../../components/MessageReporter"

export const TranslationEdit = () => {
    const { id } = useParams()

    const { addMessage } = useMessageReport()
    const navigate = useNavigate()
    const { user, getAccessTokenSilently } = useAuth0()

    const [translation, setTranslation] = useState()
    const [translationValue, setTranslationValue] = useState("")

    useEffect(() => {
        getAccessTokenSilently()
            .then((token) =>
                ApiClient.get(`/v2/management/translations/${id}`, {
                    Authorization: `Bearer ${token}`,
                })
            )
            .then((response) => {
                setTranslation(response.data)
                setTranslationValue(response.data.translation)
            })
            .catch((err) => {
                addMessage(
                    "Failed to load translation",
                    "Something went wrong while loading the translation, " +
                        "see the console for more details.",
                    MessageType.error,
                    err
                )
            })
    }, [getAccessTokenSilently, id, addMessage, setTranslation, setTranslationValue])

    const updateTranslation = useCallback(() => {
        getAccessTokenSilently()
            .then((token) =>
                ApiClient.post(
                    `/v2/management/translations`,
                    {
                        app: translation.app,
                        key: translation.key,
                        language: translation.language,
                        translation: translationValue,
                        changedby: user.email,
                    },
                    {
                        Authorization: `Bearer ${token}`,
                    }
                )
            )
            .then(() => {
                navigate(`/translations`)
            })
            .catch((err) => {
                addMessage(
                    "Failed to update translation",
                    "Something went wrong while updating the translation, " +
                        "see the console for more details.",
                    MessageType.error,
                    err
                )
            })
    }, [translation, translationValue, user, getAccessTokenSilently, navigate, addMessage])

    return (
        <Row className="content-section">
            <Col>
                <h2>Edit translation</h2>
                <Form.Group className="mb-3">
                    <Form.Label>Key</Form.Label>
                    <Form.Control type="text" value={translation?.key} disabled />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Translation</Form.Label>
                    <Form.Control
                        type="text"
                        value={translationValue}
                        onChange={(e) => setTranslationValue(e.target.value)}
                    />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>App</Form.Label>
                    <Form.Control type="text" value={translation?.app} disabled />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>Language</Form.Label>
                    <Form.Control type="text" value={translation?.language} disabled />
                </Form.Group>
                <button onClick={updateTranslation} className="btn btn-primary">
                    Save
                </button>
            </Col>
        </Row>
    )
}
